
import { observer } from '@legendapp/state/react';
import { useIsFetching } from '@tanstack/react-query';
import { useCallback, useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import InlineLoader from '../../../components/ui/inline-loader/InlineLoader';
import { IUseGetFilesKey } from '../../../query/getFiles/useGetFiles.query';
import { pageState$ } from '../../../state';
import './CategoryBreadcrumbs.scss';
export interface IBreadCrumb {
    title: string,
    path: string
}

const CategoryBreadCrumbs = observer(() => {
    const { pathname } = useLocation();

    const isCategoryLoadingState = useIsFetching({
        queryKey: [IUseGetFilesKey]
    });

    const [breadCrumbs, setBreadCrumbs] = useState<IBreadCrumb[] | undefined>(undefined);

    const prepareBreadCrumbs = useCallback((pathName: string) => {
        if (!pathName ||
            !pathName.length) {
            return []
        }

        let output: IBreadCrumb[] = [{
            title: 'Home',
            path: ''
        }];

        const currentPaths = pathName.split('/').filter(item => item);

        // if (isOverlayActive !== null || isCategoryLoadingState == 0) {
        //     currentPaths.splice(currentPaths.length - 1, 1);
        // }

        currentPaths.forEach((item, index) => {
            const title = item
                .split('-')
                .map(item => item.trim().replace(/[^a-zA-Z0-9]/g, ''))
                .map(item => item.charAt(0).toUpperCase() + item.slice(1))
                .join(' ');

            // const path = item
            //     .split('-')
            //     //.map(item => item.trim().toLowerCase().replace(/[^a-zA-Z0-9]/g, ''))
            //     .map(item => item.trim().replace(/[^a-zA-Z0-9]/g, ''))
            //     .join('-');



            output.push({
                title,
                path: !index ? item : output[1].path + '/' + item
            });
        });

        return output;
    }, []);

    const data = pageState$.activeItem.data.get();

    useEffect(() => {
        if (isCategoryLoadingState === 0) {
            const updatedBreadCrumbs = prepareBreadCrumbs(decodeURIComponent(pathname));
            setBreadCrumbs(updatedBreadCrumbs);
        }
    }, [prepareBreadCrumbs, pathname, isCategoryLoadingState])

    return (
        breadCrumbs === undefined ?
            <> <InlineLoader /></> :
            <>
                <ul className={`breadcrumbs list d-flex ${!data || data.length === 0 ? 'breadcrumbs--loading' : ''}`}>
                    {
                        breadCrumbs.map((item) => (
                            <li key={item.title} className="breadcrumbs__item">
                                <NavLink to={'/' + item.path} className="breadcrumbs__link">
                                    <span className="home-nav__description d-flex">
                                        {item.title}
                                    </span>
                                </NavLink>
                            </li>
                        ))
                    }
                </ul>
            </>
    )
})

export default CategoryBreadCrumbs;
